import React from 'react';
import { Countdown } from './ui/Countdown';
import { Button } from './ui/Button';
import { Star, Check, AlertTriangle, Shield, Lock, Zap } from 'lucide-react';
const URL_COMBO = 'https://www.compradigitalya.com/cart/42804528906311:1';
const URL_NEGOCIO = 'https://www.compradigitalya.com/cart/42804644479047:1';
export function FinalCTA() {
  return <section className="relative overflow-hidden py-16 md:py-24 px-4" data-id="element-112">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-primary/8 blur-[140px] rounded-full pointer-events-none" data-id="element-113" />

      <div className="relative max-w-5xl mx-auto text-center" data-id="element-114">
        <h2 className="text-3xl md:text-5xl font-extrabold mb-4 leading-tight" data-id="element-115">
          Todo tu año de HIIT, <span className="text-primary" data-id="element-116">resuelto.</span>
        </h2>

        <p className="text-base md:text-xl text-zinc-300 mb-10 md:mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-117">
          300+ clases listas para dar. 52 semanas de progresión. Cero
          improvisación.
        </p>

        {/* COUNTDOWN */}
        <div className="mb-6 md:mb-8" data-id="element-118">
          <p className="text-sm md:text-base font-bold text-zinc-400 mb-4 uppercase tracking-wide" data-id="element-119">
            ⏰ El precio cierra en:
          </p>
          <Countdown data-id="element-120" />
        </div>

        <div className="flex flex-wrap justify-center gap-2 mb-12 max-w-2xl mx-auto" data-id="element-121">
          <div className="inline-flex items-center gap-1.5 bg-red-500/10 border border-red-500/30 text-red-400 px-3 md:px-4 py-1.5 rounded-full font-bold text-[11px] md:text-sm" data-id="element-122">
            <AlertTriangle className="w-3 h-3 md:w-3.5 md:h-3.5" data-id="element-123" /> El precio de
            lanzamiento termina hoy
          </div>
          <div className="inline-flex items-center gap-1.5 bg-red-500/10 border border-red-500/30 text-red-400 px-3 md:px-4 py-1.5 rounded-full font-bold text-[11px] md:text-sm" data-id="element-124">
            <AlertTriangle className="w-3 h-3 md:w-3.5 md:h-3.5" data-id="element-125" /> Después sube
            y no vuelve a bajar
          </div>
        </div>

        {/* TWO CARDS — Recommended first (mobile-first emphasis) */}
        <div className="grid md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto mb-10" data-id="element-126">
          {/* Combo + Turnos Llenos (recommended) */}
          <div className="relative bg-surface border-2 border-primary rounded-3xl p-6 md:p-8 flex flex-col text-left shadow-[0_0_40px_rgba(249,168,212,0.2)] md:order-2" data-id="element-127">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-primary text-black font-extrabold px-4 py-1 rounded-full text-xs md:text-sm flex items-center gap-1 whitespace-nowrap shadow-[0_0_15px_rgba(249,168,212,0.6)]" data-id="element-128">
              <Star className="w-3.5 h-3.5 fill-black" data-id="element-129" /> MÁS ELEGIDO
            </div>

            <div className="flex items-center gap-2 mb-2" data-id="element-130">
              <span className="text-3xl md:text-4xl" data-id="element-131">🏆</span>
              <h3 className="text-xl md:text-2xl font-extrabold" data-id="element-132">
                Combo + Turnos Llenos
              </h3>
            </div>
            <p className="text-primary text-sm font-medium mb-5" data-id="element-133">
              6 Tomos + 6 Bonos + Manual de Negocio
            </p>

            <ul className="space-y-2 mb-6 flex-grow" data-id="element-134">
              {['TODO el Combo Completo HIIT Pro', 'Manual Turnos Llenos', 'Guiones para subir cuota + WhatsApp', 'Instagram + sistema de cobros sin mora'].map((f, i) => <li key={i} className="flex items-start gap-2 text-sm" data-id="element-135">
                  <Check className="w-4 h-4 text-primary shrink-0 mt-0.5" data-id="element-136" />
                  <span className="text-white font-medium" data-id="element-137">{f}</span>
                </li>)}
            </ul>

            <div className="mb-5" data-id="element-138">
              <div className="text-zinc-500 line-through text-sm font-bold mb-1" data-id="element-139">
                $76.900
              </div>
              <div className="text-3xl md:text-4xl font-extrabold text-primary" data-id="element-140">
                $27.990{' '}
                <span className="text-base md:text-lg text-zinc-400" data-id="element-141">ARS</span>
              </div>
            </div>

            <Button href={URL_NEGOCIO} fullWidth className="py-3.5 text-base shadow-[0_0_25px_rgba(249,168,212,0.4)]" data-id="element-142">
              👉 QUIERO EL COMBO COMPLETO
            </Button>
          </div>

          {/* Combo Completo HIIT Pro */}
          <div className="bg-surface border border-zinc-800 rounded-3xl p-6 md:p-8 flex flex-col text-left md:order-1" data-id="element-143">
            <div className="flex items-center gap-2 mb-2" data-id="element-144">
              <span className="text-3xl md:text-4xl" data-id="element-145">📘</span>
              <h3 className="text-xl md:text-2xl font-extrabold" data-id="element-146">
                Combo Completo HIIT Pro
              </h3>
            </div>
            <p className="text-zinc-400 text-sm mb-5" data-id="element-147">6 Tomos + 6 Bonos</p>

            <ul className="space-y-2 mb-6 flex-grow" data-id="element-148">
              {['300+ clases listas', '6 bonos estratégicos', 'Garantía 7 días'].map((f, i) => <li key={i} className="flex items-start gap-2 text-sm" data-id="element-149">
                  <Check className="w-4 h-4 text-primary shrink-0 mt-0.5" data-id="element-150" />
                  <span className="text-zinc-200" data-id="element-151">{f}</span>
                </li>)}
            </ul>

            <div className="mb-5" data-id="element-152">
              <div className="text-zinc-500 line-through text-sm font-bold mb-1" data-id="element-153">
                $51.900
              </div>
              <div className="text-3xl md:text-4xl font-extrabold text-white" data-id="element-154">
                $19.990{' '}
                <span className="text-base md:text-lg text-zinc-400" data-id="element-155">ARS</span>
              </div>
            </div>

            <Button href={URL_COMBO} fullWidth className="py-3.5 text-base" data-id="element-156">
              👉 QUIERO MI COMBO AHORA
            </Button>
          </div>
        </div>

        {/* TRUST */}
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs md:text-sm text-zinc-400 font-medium" data-id="element-157">
          <span className="flex items-center gap-1.5" data-id="element-158">
            <Lock className="w-3.5 h-3.5 text-primary" data-id="element-159" /> Pago 100% seguro
          </span>
          <span className="text-zinc-700" data-id="element-160">·</span>
          <span className="flex items-center gap-1.5" data-id="element-161">
            <Zap className="w-3.5 h-3.5 text-primary" data-id="element-162" /> Acceso en 5 minutos
          </span>
          <span className="text-zinc-700" data-id="element-163">·</span>
          <span className="flex items-center gap-1.5" data-id="element-164">
            <Shield className="w-3.5 h-3.5 text-primary" data-id="element-165" /> Garantía de 7 días
          </span>
        </div>
      </div>
    </section>;
}